
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { Button, Container, Card } from "react-bootstrap";
import { useAppDispatch, withSkipGlobalApiError } from "src/redux/storeHooks";
import { validateUserSessionPostAsync } from "src/redux/actions/authActions";
import useAppToast from "src/hooks/useAppToast";
import { accessSessionTokenKeyName, refreshSessionTokenKeyName } from "src/utils/constants";
import { useLocation, useNavigate,Link } from "react-router-dom";
import {toAbsoluteUrl} from 'src/marketConnect/helpers'

// ✅ Validation Schema
const OtpSchema = Yup.object().shape({
  otp: Yup.string()
    .matches(/^[0-9]+$/, "Only digits allowed")
    .length(6, "Authentication Code must be 6 digits")
    .required("Authentication Code is required"),
});

const MfaLogin = () => {
  const dispatch = useAppDispatch();
  const { successToast, errorToast } = useAppToast();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { sessionToken,email, password}: any = location.state || {};

  const handleOtpSubmit = async (values: { otp: string }) => {
    try {
      // console.log("token",location.state)
      const response = await  dispatch(validateUserSessionPostAsync(withSkipGlobalApiError({session_token:sessionToken,otp:values.otp})));
      if (response.payload?.access) {
        localStorage.setItem(accessSessionTokenKeyName, response.payload.access);
        localStorage.setItem(refreshSessionTokenKeyName, response.payload.refresh);
        successToast("Logged in successfully");
        navigate("/dashboard");
      } 
      
      else {
   
     
        if(response.payload?.status=='400' && response.payload?.data?.hasOwnProperty("is_valid") && !response.payload?.data?.is_valid ){
          errorToast(response?.payload?.data?.message );
          navigate("/auth/login");
        }else{errorToast(response?.payload?.data?.message)}
      }
    } catch (err) {
      errorToast("Something went wrong, please try again");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    // console.log(location.state,"loc")
    if (!location.state) {
      navigate("/auth");
    }
  }, []);

  return (
    <div className="d-flex align-items-center justify-content-center vh-100 ">
      <Card
        className="text-center"
        style={{
          width: "500px", 
          padding: "30px",
          border: "none",    
          boxShadow: "none",  
          backgroundColor: "#fcfcfc",
        }}
      >
        {/* Logo (replace with your app logo if needed) */}
        <div className="mb-3">
          {/* <i
            className="bi bi-github"
            style={{ fontSize: "2.5rem", color: "#333" }}
          ></i> */}
             {/* begin::Logo */}
                    <a href="https://constacloud.com/commercium/" target="_blank" rel="noopener noreferrer"className=''>
                      <img
                        alt='Logo'
                        src={toAbsoluteUrl('/media/logos/favicon.png')}
                        className='h-sm-90px h-50px'     //separate page 
                   
                      />
                    </a>
                    {/* end::Logo */}
        </div>

        <h4 className="fw-bold mb-2">Two-Factor Authentication</h4>
        <p className="text-muted mb-4" style={{ fontSize: "0.9rem" }}>
          Enter the code from your 2-factor authentication app.
        </p>

        <Formik
          initialValues={{ otp: "" }}
          validationSchema={OtpSchema}
          onSubmit={handleOtpSubmit}
        >
          {({ isSubmitting }) => (
            <Form>
              <div className="mb-3">
                <Field
                  type="text"
                  name="otp"
                  className="form-control text-center"
                  placeholder="Enter 6 digit code"
                  style={{
                    borderRadius: "6px",
                    height: "45px",
                    fontSize: "1.1rem",
                    letterSpacing: "3px",
                  }}
                />
                <ErrorMessage
                  name="otp"
                  component="div"
                  className="text-danger mt-1 small"
                />
              </div>

              <Button
                type="submit"
                style={{
        
                  border: "none",
                  height: "45px",
                  fontWeight: "600",
                }}
                className="w-100 mb-3"
                disabled={isSubmitting || loading}
              >
                {loading ? "Verifying..." : "Verify"}
              </Button>
            </Form>
          )}
        </Formik>
            <div className='text-gray-500 text-center fw-semibold fs-6 mt-5'>
                  Want to sign in different account?{" "}
                  <Link to='/auth' className='link-primary'>
                    Sign in
                  </Link>
                </div>
      </Card>
    </div>
  );
};

export default MfaLogin;




